
export const AcademicCategoriesModal = () => `
    <div id="academic-categories-container" class="hidden">
        <button id="close-cats-btn" class="close-modal-btn">✕</button>
        <div class="honeycomb-grid">
            <button class="honeycomb-cell category-btn" data-category="tarih" aria-label="Tarih Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">📜</span>
                <span class="cat-name">TARİH</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="cografya" aria-label="Coğrafya Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🌍</span>
                <span class="cat-name">COĞRAFYA</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="psikoloji" aria-label="Psikoloji Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🧠</span>
                <span class="cat-name">PSİKOLOJİ</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="sosyoloji" aria-label="Sosyoloji Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">👥</span>
                <span class="cat-name">SOSYOLOJİ</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="edebiyat" aria-label="Edebiyat Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">📚</span>
                <span class="cat-name">EDEBİYAT</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="karisik" aria-label="Karışık Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🎲</span>
                <span class="cat-name">KARIŞIK</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="fen_bilimleri" aria-label="Fen Bilimleri Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🧬</span>
                <span class="cat-name">FEN BİL.</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="siyaset" aria-label="Siyaset Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🗳️</span>
                <span class="cat-name">SİYASET</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="din" aria-label="Din Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🕌</span>
                <span class="cat-name">DİN</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="sinema" aria-label="Sinema Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🎬</span>
                <span class="cat-name">SİNEMA</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="spor" aria-label="Spor Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">⚽</span>
                <span class="cat-name">SPOR</span>
            </button>
            <button class="honeycomb-cell category-btn" data-category="mythology" aria-label="Mitoloji Kategorisi Soru Çöz">
                <span class="icon" aria-hidden="true">🏛️</span>
                <span class="cat-name">MİTOLOJİ</span>
            </button>
        </div>
    </div>
`;
